var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage-content-root" },
    [
      _c(
        "div",
        { staticClass: "filter-wrap" },
        [
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("SKUID:")]),
              _c("el-input", {
                staticClass: "w-140",
                attrs: {
                  placeholder: "请输入SKUID",
                  size: "small",
                  clearable: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.handleSkuIdInput("mainGoodsQuery")
                  },
                },
                model: {
                  value: _vm.mainGoodsQuery.skuId,
                  callback: function ($$v) {
                    _vm.$set(_vm.mainGoodsQuery, "skuId", $$v)
                  },
                  expression: "mainGoodsQuery.skuId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("SKU编码:")]),
              _c("el-input", {
                staticClass: "w-140",
                attrs: {
                  placeholder: "请输入SKU编码",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.mainGoodsQuery.skuCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.mainGoodsQuery, "skuCode", $$v)
                  },
                  expression: "mainGoodsQuery.skuCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("商品名称:")]),
              _c("el-input", {
                staticClass: "w-160",
                attrs: {
                  placeholder: "请输入商品名称",
                  size: "small",
                  clearable: "",
                },
                model: {
                  value: _vm.mainGoodsQuery.skuName,
                  callback: function ($$v) {
                    _vm.$set(_vm.mainGoodsQuery, "skuName", $$v)
                  },
                  expression: "mainGoodsQuery.skuName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("品牌:")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "w-170",
                  attrs: {
                    placeholder: "请选择品牌",
                    size: "small",
                    filterable: "",
                    clearable: "",
                    "remote-method": _vm.brandRemoteMethod,
                  },
                  on: { "visible-change": _vm.onBrandVisibleChange },
                  model: {
                    value: _vm.mainGoodsQuery.brandId,
                    callback: function ($$v) {
                      _vm.$set(_vm.mainGoodsQuery, "brandId", $$v)
                    },
                    expression: "mainGoodsQuery.brandId",
                  },
                },
                _vm._l(_vm.brandOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.brandName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("供应商:")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "w-170",
                  attrs: {
                    placeholder: "请选择供应商",
                    size: "small",
                    filterable: "",
                    clearable: "",
                    "remote-method": _vm.supplierRemoteMethod,
                  },
                  on: { "visible-change": _vm.onSupplierVisibleChange },
                  model: {
                    value: _vm.mainGoodsQuery.supplierId,
                    callback: function ($$v) {
                      _vm.$set(_vm.mainGoodsQuery, "supplierId", $$v)
                    },
                    expression: "mainGoodsQuery.supplierId",
                  },
                },
                _vm._l(_vm.supplierOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.supplierName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("商品分类:")]),
              _c("el-cascader", {
                staticClass: "category-cascader",
                attrs: {
                  options: _vm.categoryTreeOptions,
                  props: _vm.categoryCascaderProps,
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择",
                  size: "small",
                },
                model: {
                  value: _vm.mainGoodsQuery.category,
                  callback: function ($$v) {
                    _vm.$set(_vm.mainGoodsQuery, "category", $$v)
                  },
                  expression: "mainGoodsQuery.category",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-item" },
            [
              _c("span", { staticClass: "label" }, [_vm._v("排序:")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "w-220",
                  attrs: { size: "small" },
                  model: {
                    value: _vm.mainGoodsQuery.sortKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.mainGoodsQuery, "sortKey", $$v)
                    },
                    expression: "mainGoodsQuery.sortKey",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "更新时间降序", value: "updateTime_desc" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "更新时间升序", value: "updateTime_asc" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: {
                      label: "默认售价降序",
                      value: "defaultPrice_desc",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "默认售价升序", value: "defaultPrice_asc" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleMainGoodsQuery },
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", plain: "" },
              on: { click: _vm.resetMainGoodsFilter },
            },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tool-wrap" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: [
                    "admin:shopintegral:activity:product:importActivityProduct",
                  ],
                  expression:
                    "['admin:shopintegral:activity:product:importActivityProduct']",
                },
              ],
              attrs: { type: "primary", size: "mini", disabled: _vm.readonly },
              on: { click: _vm.openBatchDialog },
            },
            [_vm._v("导入商品")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.mainGoodsListLoading,
              expression: "mainGoodsListLoading",
            },
          ],
          staticClass: "goods-table",
          attrs: { data: _vm.mainGoodsList, size: "small", border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "skuId", label: "SKUID", "min-width": "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "skuCode", label: "SKU编码", "min-width": "90" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "goodsName", label: "商品名称", "min-width": "120" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "brand", label: "品牌", "min-width": "70" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "supplier", label: "供应商", "min-width": "90" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "firstCategory",
              label: "一级分类",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "secondCategory",
              label: "二级分类",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "thirdCategory",
              label: "三级分类",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "retailPrice",
              label: "零售价(￥)",
              "min-width": "70",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "costPrice",
              label: "成本价(￥)",
              "min-width": "70",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "supplyPrice",
              label: "供货价(￥)",
              "min-width": "90",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "defaultPrice",
              label: "默认售价(￥)",
              "min-width": "90",
            },
          }),
          _vm._v(" "),
          _vm.activityType === 2
            ? _c("el-table-column", {
                attrs: {
                  prop: "showSellPrice",
                  label: "售价(￥)",
                  "min-width": "70",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activityType === 1
            ? _c(
                "el-table-column",
                { attrs: { prop: "enablePoints", "min-width": "120" } },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "table-header-with-tip" },
                      [
                        _c("span", [_vm._v("是否返积分")]),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              "max-width": 320,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  "当返积分为“是”，则表示当前商品在移动端展示返积分标识;当返积分为“否”，则表示当前商品在移动端不展示返积分标识"
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "table-header-tip-wrap" },
                              [_c("i", { staticClass: "el-icon-question" })]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "platformStatusDesc",
              label: "平台上下架",
              "min-width": "90",
            },
          }),
          _vm._v(" "),
          !_vm.readonly
            ? _c("el-table-column", {
                attrs: { label: "操作", "min-width": "70", fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: [
                                    "admin:shopintegral:activity:product:deleteById",
                                  ],
                                  expression:
                                    "['admin:shopintegral:activity:product:deleteById']",
                                },
                              ],
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeGoods(scope.row, false)
                                },
                              },
                            },
                            [_vm._v("移除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1609297056
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("template", { slot: "empty" }, [
            _vm.showImportEmptyBlock
              ? _c(
                  "div",
                  { staticClass: "empty-wrap" },
                  [
                    _c("i", {
                      staticClass: "el-icon-shopping-bag-2 empty-icon",
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: [
                              "admin:shopintegral:activity:product:importActivityProduct",
                            ],
                            expression:
                              "['admin:shopintegral:activity:product:importActivityProduct']",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "mini",
                          disabled: _vm.readonly,
                        },
                        on: { click: _vm.openBatchDialog },
                      },
                      [_vm._v("去导入")]
                    ),
                  ],
                  1
                )
              : _c("span", { staticClass: "el-table__empty-text" }, [
                  _vm._v("暂无数据"),
                ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "goods-pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.mainGoodsPagination.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.mainGoodsPagination.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.mainGoodsTotal,
            },
            on: {
              "size-change": _vm.handleMainGoodsSizeChange,
              "current-change": _vm.handleMainGoodsPageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入商品列表",
            visible: _vm.batchDialogVisible,
            width: "92%",
            "append-to-body": "",
            "close-on-click-modal": false,
            "before-close": _vm.handleBatchDialogBeforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchDialogVisible = $event
            },
            open: _vm.onBatchDialogOpen,
          },
        },
        [
          _c(
            "div",
            { staticClass: "filter-wrap batch-filter-wrap" },
            [
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("SKUID:")]),
                  _c("el-input", {
                    staticClass: "w-140",
                    attrs: {
                      placeholder: "请输入SKUID",
                      size: "small",
                      clearable: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.handleSkuIdInput("batchGoodsQuery")
                      },
                    },
                    model: {
                      value: _vm.batchGoodsQuery.skuId,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchGoodsQuery, "skuId", $$v)
                      },
                      expression: "batchGoodsQuery.skuId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("SKU编码:")]),
                  _c("el-input", {
                    staticClass: "w-140",
                    attrs: {
                      placeholder: "请输入SKU编码",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.batchGoodsQuery.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchGoodsQuery, "skuCode", $$v)
                      },
                      expression: "batchGoodsQuery.skuCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("商品名称:")]),
                  _c("el-input", {
                    staticClass: "w-160",
                    attrs: {
                      placeholder: "请输入商品名称",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.batchGoodsQuery.skuName,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchGoodsQuery, "skuName", $$v)
                      },
                      expression: "batchGoodsQuery.skuName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("品牌:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-170",
                      attrs: {
                        placeholder: "请选择品牌",
                        size: "small",
                        filterable: "",
                        clearable: "",
                        "remote-method": _vm.brandRemoteMethod,
                      },
                      on: { "visible-change": _vm.onBrandVisibleChange },
                      model: {
                        value: _vm.batchGoodsQuery.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchGoodsQuery, "brandId", $$v)
                        },
                        expression: "batchGoodsQuery.brandId",
                      },
                    },
                    _vm._l(_vm.brandOptions, function (item) {
                      return _c("el-option", {
                        key: "batch-brand-" + item.id,
                        attrs: { label: item.brandName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("供应商:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-170",
                      attrs: {
                        placeholder: "请选择供应商",
                        size: "small",
                        filterable: "",
                        clearable: "",
                        "remote-method": _vm.supplierRemoteMethod,
                      },
                      on: { "visible-change": _vm.onSupplierVisibleChange },
                      model: {
                        value: _vm.batchGoodsQuery.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchGoodsQuery, "supplierId", $$v)
                        },
                        expression: "batchGoodsQuery.supplierId",
                      },
                    },
                    _vm._l(_vm.supplierOptions, function (item) {
                      return _c("el-option", {
                        key: "batch-supplier-" + item.id,
                        attrs: { label: item.supplierName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("商品分类:")]),
                  _c("el-cascader", {
                    staticClass: "category-cascader",
                    attrs: {
                      options: _vm.categoryTreeOptions,
                      props: _vm.categoryCascaderProps,
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择",
                      size: "small",
                    },
                    model: {
                      value: _vm.batchGoodsQuery.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchGoodsQuery, "category", $$v)
                      },
                      expression: "batchGoodsQuery.category",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("排序:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "w-220",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.batchGoodsQuery.sortKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchGoodsQuery, "sortKey", $$v)
                        },
                        expression: "batchGoodsQuery.sortKey",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "更新时间降序",
                          value: "updateTime_desc",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          label: "更新时间升序",
                          value: "updateTime_asc",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          label: "默认售价降序",
                          value: "defaultPrice_desc",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: {
                          label: "默认售价升序",
                          value: "defaultPrice_asc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleBatchGoodsQuery },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small", plain: "" },
                  on: { click: _vm.resetBatchGoodsFilter },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tool-wrap dialog-tool-wrap" }, [
            _c(
              "div",
              { staticClass: "dialog-tool-actions" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: [
                          "admin:shopintegral:activity:product:importActivityProduct",
                        ],
                        expression:
                          "['admin:shopintegral:activity:product:importActivityProduct']",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      size: "mini",
                      disabled: _vm.readonly,
                    },
                    on: { click: _vm.openImportDialog },
                  },
                  [_vm._v("点击上传导入文件")]
                ),
                _vm.importBatchId
                  ? _c("div", { staticClass: "batch-tip" }, [
                      _vm._v("当前批次：" + _vm._s(_vm.importBatchId)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.batchGoodsListLoading,
                  expression: "batchGoodsListLoading",
                },
              ],
              staticClass: "goods-table batch-goods-table",
              attrs: {
                data: _vm.batchGoodsList,
                size: "small",
                border: "",
                "max-height": "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "skuId", label: "SKUID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "SKU编码", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsName",
                  label: "商品名称",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brand", label: "品牌", "min-width": "70" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "supplier", label: "供应商", "min-width": "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "firstCategory",
                  label: "一级分类",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "secondCategory",
                  label: "二级分类",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "thirdCategory",
                  label: "三级分类",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailPrice",
                  label: "零售价(￥)",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "costPrice",
                  label: "成本价(￥)",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供货价(￥)",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "defaultPrice",
                  label: "默认售价(￥)",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _vm.activityType === 2
                ? _c("el-table-column", {
                    attrs: {
                      prop: "showSellPrice",
                      label: "售价(￥)",
                      "min-width": "70",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activityType === 1
                ? _c(
                    "el-table-column",
                    { attrs: { prop: "enablePoints", "min-width": "120" } },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "span",
                          { staticClass: "table-header-with-tip" },
                          [
                            _c("span", [_vm._v("是否返积分")]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  placement: "top",
                                  "max-width": 320,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "当返积分为“是”，则表示当前商品在移动端展示返积分标识;当返积分为“否”，则表示当前商品在移动端不展示返积分标识"
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "table-header-tip-wrap" },
                                  [_c("i", { staticClass: "el-icon-question" })]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "platformStatusDesc",
                  label: "平台上下架",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              !_vm.readonly
                ? _c("el-table-column", {
                    attrs: { label: "操作", "min-width": "70", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:shopintegral:activity:product:deleteById",
                                      ],
                                      expression:
                                        "['admin:shopintegral:activity:product:deleteById']",
                                    },
                                  ],
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeGoods(scope.row, true)
                                    },
                                  },
                                },
                                [_vm._v("移除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2246044011
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _vm.showBatchImportEmptyBlock
                  ? _c(
                      "div",
                      { staticClass: "empty-wrap dialog-empty-wrap" },
                      [
                        _c("i", {
                          staticClass: "el-icon-shopping-bag-2 empty-icon",
                        }),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:shopintegral:activity:product:importActivityProduct",
                                ],
                                expression:
                                  "['admin:shopintegral:activity:product:importActivityProduct']",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              size: "mini",
                              disabled: _vm.readonly,
                            },
                            on: { click: _vm.openImportDialog },
                          },
                          [_vm._v("去导入")]
                        ),
                      ],
                      1
                    )
                  : _c("span", { staticClass: "el-table__empty-text" }, [
                      _vm._v("暂无数据"),
                    ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "goods-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.batchGoodsPagination.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.batchGoodsPagination.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.batchGoodsTotal,
                },
                on: {
                  "size-change": _vm.handleBatchGoodsSizeChange,
                  "current-change": _vm.handleBatchGoodsPageChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.importBatchId
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.batchCancelLoading },
                      on: { click: _vm.handleCancelBatch },
                    },
                    [_vm._v("关闭")]
                  )
                : _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: [
                            "admin:shopintegral:activity:product:cancelImportBatch",
                          ],
                          expression:
                            "['admin:shopintegral:activity:product:cancelImportBatch']",
                        },
                      ],
                      attrs: { loading: _vm.batchCancelLoading },
                      on: { click: _vm.handleCancelBatch },
                    },
                    [_vm._v("取消")]
                  ),
              !_vm.readonly
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: [
                            "admin:shopintegral:activity:product:submitImportBatch",
                          ],
                          expression:
                            "['admin:shopintegral:activity:product:submitImportBatch']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        loading: _vm.batchSubmitLoading,
                        disabled:
                          _vm.importBatchId == null || _vm.importBatchId === "",
                      },
                      on: { click: _vm.handleSubmitBatch },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "import-dialog",
          attrs: {
            title: "商品导入",
            visible: _vm.importDialogVisible,
            width: "560px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            closed: _vm.resetImportDialog,
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title:
                "请先下载导入模板，按模板格式填写商品信息后上传；如果重新编辑了导入文件，请重新选择后再导入",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "import-dialog-center" },
            [
              _c(
                "div",
                { staticClass: "template-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleDownloadTemplate },
                    },
                    [_vm._v("下载模板")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "template-file-name" }, [
                    _vm._v(_vm._s(_vm.templateFileName)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  ref: "importUpload",
                  staticClass: "upload-area",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "show-file-list": false,
                    "on-change": _vm.handleImportFileChange,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload upload-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _c("div", [_vm._v("点击或拖拽文件到此区域上传")]),
                    _c("div", [_vm._v("支持扩展名：.xlsx、.xls")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.importFileName
                ? _c(
                    "div",
                    { staticClass: "file-name" },
                    [
                      _c("div", { staticClass: "selected-file-info" }, [
                        _c("i", {
                          staticClass: "el-icon-success selected-file-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "selected-file-text" }, [
                          _vm._v(_vm._s(_vm.importFileName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "selected-file-remove",
                          attrs: { type: "text" },
                          on: { click: _vm.handleRemoveImportFile },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.importSubmitLoading },
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: [
                        "admin:shopintegral:activity:product:importActivityProduct",
                      ],
                      expression:
                        "['admin:shopintegral:activity:product:importActivityProduct']",
                    },
                  ],
                  attrs: { type: "primary", loading: _vm.importSubmitLoading },
                  on: { click: _vm.handleConfirmImport },
                },
                [_vm._v("确定导入")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }